import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQ = [
  ["What services does Pelico Data offer?", "Pelico Data provides cutting-edge digital solutions, including remote typing work, automation tools, and workforce management for distributed teams."],
  ["How can I find remote work opportunities?", "Once added by an admin, you'll receive login credentials by email. Sign in and start typing your assigned pages at your own pace."],
  ["Is Pelico Data suitable for freelancers?", "Absolutely. Freelancers can collaborate, build their typing portfolio, and access exclusive remote opportunities through our ecosystem."],
  ["How does Pelico Data ensure safety and trust?", "All accuracy is graded automatically with character-level diff. No human bias, no manual review delays — your results are real-time."],
  ["What is the maximum project size?", "Each project is capped at 500 pages to maintain quality. Admins can assign multiple projects."],
];

export default function FaqPage() {
  const [open, setOpen] = useState(0);
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20">
      <div className="chip mb-6">FAQ</div>
      <h1 className="font-display text-5xl font-bold tracking-tight">Frequently Asked Questions</h1>
      <p className="mt-4 text-zinc-600">Everything you need to know before you start.</p>

      <div className="mt-10 divide-y divide-[var(--line)] border-y border-[var(--line)]">
        {FAQ.map(([q, a], i) => (
          <div key={q} data-testid={`faq-item-${i}`}>
            <button className="w-full flex items-center justify-between gap-4 py-5 text-left" onClick={() => setOpen(open === i ? -1 : i)}>
              <span className="font-display font-semibold text-lg">{q}</span>
              {open === i ? <Minus size={18} /> : <Plus size={18} />}
            </button>
            {open === i && <div className="pb-6 text-zinc-600 leading-relaxed">{a}</div>}
          </div>
        ))}
      </div>

      <div className="mt-12 text-xs text-zinc-500 leading-relaxed">
        <strong>Disclaimer:</strong> Information is provided for general guidance. Pelico Data reserves the right to update terms and modify access at any time.
      </div>
    </div>
  );
}
